module.exports = __webpack_public_path__ + "static/media/visa.8bef3836.svg";